import * as moment from 'moment';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { HrDashboardService } from '../../service/hr-dashboard/hr-dashboard.service';
import { MessageService } from 'src/app/utility/services/message/message.service';
import { EbHrDashboardEmailType } from 'src/app/utility/enum/global-enum';
import { MatDialog } from '@angular/material';
import { DialogAllClaimReportComponent } from './dialog-all-claim-report/dialog-all-claim-report.component';

@Component({
  selector: 'app-hr-dashboard',
  templateUrl: './hr-dashboard.component.html',
  styleUrls: ['./hr-dashboard.component.scss']
})
export class HrDashboardComponent implements OnInit {

  allClaimReport = EbHrDashboardEmailType.AllClaimReport;
  groupPolicyHr: any = [];
  policyYears: any = []
  reportSummery: any;
  minimumDate: any;
  maximumDate: any;
  searchBtnClicked = false;

  messageList = [
    { title: "All Claim Report", type: EbHrDashboardEmailType.AllClaimReport, isActive: true  },
    { title: "Life & Disability Claim Status", type: EbHrDashboardEmailType.LifeAndDisabilityClaimStatus, isActive: false },
    { title: "Group Medical Claim Status", type: EbHrDashboardEmailType.GroupMedicalClaimStatus, isActive: false }
  ];

  inputForm = this.fb.group({
    groupPolicyId: [null, [Validators.required]],
    fromDate: [null, [Validators.required]],
    toDate: [null]
  });

  constructor(
    private fb: FormBuilder,
    public dialog: MatDialog,
    private hrDashboardService: HrDashboardService,
    private messageService: MessageService,
  ) { }

  ngOnInit() {
    this.getAllGroupPolicyByHr();

    this.inputForm.get('groupPolicyId').valueChanges.subscribe(() => {
      this.policyYears = null;
    })
  }

  getAllGroupPolicyByHr() {
    this.hrDashboardService.getGroupPolicyByHrUser().subscribe(res => {
      this.groupPolicyHr = res;
    }, err => {

    });
  }

  getReport() {
    if(this.inputForm.valid){
      const { fromDate, toDate, groupPolicyId } = this.inputForm.value;
      this.hrDashboardService.getQueueReportByGroup({ fromDate, toDate, groupPolicyId })
      .subscribe(res => {
        this.reportSummery = res;
        this.getPolicyYears();
        this.searchBtnClicked = true;
      }, err => {

      });
    }
  }

  onchangeGroupPolicy() {
    const { groupPolicyId } = this.inputForm.value;

    this.inputForm.patchValue({
      fromDate: null,
      toDate: null
    });

    this.reportSummery = null;
    if (groupPolicyId) {
      this.hrDashboardService.getLastAnniversaryByPolicy(groupPolicyId).subscribe(res => {
        this.minimumDate = moment(res.effectiveDateUtc);
        this.maximumDate = moment(res.validityDateUtc);
        if(this.searchBtnClicked && this.inputForm.valid){
          this.searchBtnClicked = true;
        }
        this.searchBtnClicked = false;
      }, err => {

      });
    }
  }

  clearDates() {
    this.inputForm.reset();
    this.reportSummery = null;
    this.searchBtnClicked = false;
  }

  getPolicyYears() {
    let groupPolicyId = this.inputForm.get('groupPolicyId').value;

    this.hrDashboardService.getLastTwoAnniversariesByGroupPolicy(groupPolicyId).subscribe(res => {
      this.policyYears = res;
    }, err => {
      this.messageService.show(err.error.message, 'error');
    });
  }

  sendEbHrDashboardEmail(type: EbHrDashboardEmailType) {
      if (type == EbHrDashboardEmailType.LifeAndDisabilityClaimStatus) {

      }
      else if (type == EbHrDashboardEmailType.GroupMedicalClaimStatus) {
  
      }
      else if (type == EbHrDashboardEmailType.AllClaimReport) {
        this.openAllClaimReportDialog();
      }
  }

  openAllClaimReportDialog() {
    const dialogRef = this.dialog.open(DialogAllClaimReportComponent,{
        data: {
          policyYears: this.policyYears,
          groupPolicyId: this.inputForm.get('groupPolicyId').value
        }
      },
    );

    dialogRef.afterClosed().subscribe((result) => { });
  }
}
